real.dom = (function() {
    'use strict';

    let addRandomDelaysMaxSeconds = 0; // If this is not zero then random delay of 0-x seconds will be added to appending all resources.

    const stylesheetReadyFnQueue = {}; // Queue for handler functions when a stylesheet is loaded.
    const scriptReadyFnQueue = {};     // Queue for handler functions when a script is loaded.
    const stylesheetsReady = {};       // Which stylesheets are already loaded.

    const toggleDisabledSelector = [
        '.btn',
        'input',
        'textarea',
        'select',
        '.form-check',
        '.howspace-form-checkbox',
        '.howspace-form-radio-button',
        '.howspace-form-toggle-button'
    ].join(',');

    const showErrorNotification = () => {
        let translation = '';
        if (typeof real.translate === 'function') {
            translation = real.translate('layout_general_reload_page_error');
        } else if (typeof howspace !== 'undefined' && typeof howspace.translate === 'function') {
            translation = howspace.translate('layout_general_reload_page_error');
        }
        real.notification.show(translation, 'danger');
    };

    const addCssFileToDOM = function(href, readyFn, insertBeforeNode) {
        let errorCount      = 0;    // How many times an error occurred when trying to load the CSS file.
        let maxRetriesCount = 5;    // Maximum amount of retries of loading the CSS fails.
        let retryTimeout    = 2000; // Retry timeout in milliseconds.

        let cssFile = document.querySelector('link[href="' + href + '"]');

        if(!stylesheetReadyFnQueue[href]) {
            stylesheetReadyFnQueue[href] = [];
        }

        if(cssFile !== null) {
            // Stylesheet has been already added to DOM
            if(typeof readyFn === 'function') {
                if(stylesheetsReady[href] || cssFile.getAttribute('data-loading') !== 'true') {
                    // Stylesheet has been loaded already
                    readyFn();
                } else {
                    // Script is still loading
                    stylesheetReadyFnQueue[href].push(readyFn);
                }
            }
            return null;
        }

        if(typeof readyFn === 'function') {
            stylesheetReadyFnQueue[href].push(readyFn);
        }

        const getCssFileDomElement = function() {
            cssFile = document.createElement('link');
            cssFile.setAttribute('rel', 'stylesheet');
            cssFile.setAttribute('data-loading', 'true');
            cssFile.onerror = function() {
                errorCount++;
                cssFile.parentNode.removeChild(cssFile);

                if(errorCount < maxRetriesCount) {
                    setTimeout(getCssFileDomElement, retryTimeout);
                    return;
                }

                // Could not load the stylesheet even after retrying to load it the maximum number of times.
                //throw new Error('The stylesheet with href "' + href + '" could not be loaded even after retrying to load it ' + maxRetriesCount + ' times.');
                showErrorNotification();
            };
            cssFile.onload = function() {
                cssFile.onload = null;
                cssFile.removeAttribute('data-loading');

                stylesheetsReady[href] = true;

                stylesheetReadyFnQueue[href].forEach(function(loopReadyFn) {
                    loopReadyFn();
                });

                delete stylesheetReadyFnQueue[href];
            };
            cssFile.setAttribute('href', href);

            if(insertBeforeNode) {
                insertBeforeNode.parentNode.insertBefore(cssFile, insertBeforeNode);
            } else {
                document.head.appendChild(cssFile);
            }
        };

        // If addRandomDelaysMaxSeconds is defined force random client side
        // delays in loading all resources. Good for testing purposes.
        if(addRandomDelaysMaxSeconds !== 0) {
            var rand = parseInt(Math.random()*addRandomDelaysMaxSeconds*1000, 10);
            console.warn('Waiting ' + (rand / 1000) + ' seconds before loading stylesheet:', href);
            setTimeout(function() {
                getCssFileDomElement();
            }, rand);
            return;
        }

        getCssFileDomElement();
    };

    return {

        initJquery : function($) {
            real.dom.$body = $(document.body);
            real.dom.$document = $(document);
            real.dom.$html = $('html');
            real.dom.$head = $(document.head);
            real.dom.$window = $(window);
            real.dom.$mainBackground = $('#main-background');
            real.dom.$mainContentWrapper = $('#main-content-wrapper');
            real.dom.$top = $('#top');
            real.dom.$topNavbar = $('#top-navbar');

            // Extend jQuery with our own plugins.
            $.fn.findIncludingSelf = function(selector) {
                return this.find(selector).addBack(selector);
            };

            $.fn.dataAndAttr = function(attr, val) {
                this.data(attr, val);

                if(typeof val === 'string') {
                    this.attr('data-' + attr, val);
                } else {
                    this.attr('data-' + attr, JSON.stringify(val));
                }

                return this;
            };

            $.fn.removeDataAndAttr = function(attr) {
                const el = this;
                attr.split(' ').forEach(function(loopAttr) {
                    el.removeAttr('data-' + loopAttr).removeData(loopAttr);
                });
                return el;
            };

            // Make all scroll related event listeners passive to improve scroll performance.
            // https://stackoverflow.com/a/62177358
            jQuery.event.special.touchstart = {
                setup: function( _, ns, handle ) {
                    this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
                }
            };
            jQuery.event.special.touchmove = {
                setup: function( _, ns, handle ) {
                    this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
                }
            };
            jQuery.event.special.scroll = {
                setup: function( _, ns, handle ){
                    this.addEventListener("scroll", handle, { passive: true });
                }
            };
            jQuery.event.special.wheel = {
                setup: function( _, ns, handle ){
                    this.addEventListener("wheel", handle, { passive: true });
                }
            };
            jQuery.event.special.mousewheel = {
                setup: function( _, ns, handle ){
                    this.addEventListener("mousewheel", handle, { passive: true });
                }
            };
        },

        toggleInputForWidget : function(triggerClass, inputId) {
            $(triggerClass).each(function(index, element) {
                $(element).on('keypress', function(e) {
                    $(this).find('input')[0].click()
                })
            })
        },

        appendStylesheet : function(href, readyFn) {
            addCssFileToDOM(href, readyFn);
        },

        insertStylesheetBeforeNode : function(node, href, readyFn) {
            addCssFileToDOM(href, readyFn, node);
        },

        appendScript : function(src, readyFn, isModule) {
            let
                script,                 // Script DOM element.
                cleanSrc,               // Script src cleaned of any ?v=x version numbers.
                appendScript,           // Function to append the script to document body.
                errorCount      = 0,    // How many times an error occurred when trying to load the script.
                maxRetriesCount = 5,    // Maximum amount of retries of loading the script fails.
                retryTimeout    = 2000  // Retry timeout in milliseconds.
            ;

            script = document.querySelector('script[src="' + src + '"]');

            cleanSrc = src.replace(/\?v=.+/, '');

            if(!scriptReadyFnQueue[cleanSrc]) {
                scriptReadyFnQueue[cleanSrc] = [];
            }

            if(script !== null) {
                // Script has been already added to DOM
                if(typeof readyFn === 'function') {
                    if (script.dataset.loaded === 'true') {
                        // Script has been loaded already
                        readyFn();
                    } else {
                        // Script is still loading
                        script.addEventListener('load', readyFn, {once: true});
                    }
                }
                return;
            }

            if(typeof readyFn === 'function') {
                scriptReadyFnQueue[cleanSrc].push(readyFn);
            }

            if (typeof isModule === 'undefined') {
                isModule = src.includes('/dist/');
            }

            appendScript = function() {
                script = document.createElement('script');
                script.src = src;
                script.crossOrigin = 'anonymous';
                if (isModule) {
                    script.type = 'module';
                } else {
                    script.async = false;
                }
                script.onerror = function() {
                    errorCount++;
                    script.parentNode.removeChild(script);

                    if(errorCount < maxRetriesCount) {
                        setTimeout(appendScript, retryTimeout);
                        return;
                    }

                    // Could not load the script even after retrying to load it the maximum number of times.
                    //throw new Error('The script with src "' + src + '" could not be loaded even after retrying to load it ' + maxRetriesCount + ' times.');
                    showErrorNotification();
                };
                script.onload = function() {
                    script.onload = null;

                    if (scriptReadyFnQueue[cleanSrc]) {
                        scriptReadyFnQueue[cleanSrc].forEach(function(loopReadyFn) {
                            loopReadyFn();
                        });
                    }

                    delete scriptReadyFnQueue[cleanSrc];
                };

                document.body.appendChild(script);
            };

            // If addRandomDelaysMaxSeconds is defined force random client side
            // delays in loading all resources. Good for testing purposes.
            if(addRandomDelaysMaxSeconds !== 0) {
                var rand = parseInt(Math.random()*addRandomDelaysMaxSeconds*1000, 10);
                console.warn('Waiting ' + (rand / 1000) + ' seconds before loading script:', src);
                setTimeout(function() {
                    appendScript();
                }, rand);
                return;
            }

            appendScript();
        },

        appendStylesheets : function(hrefs, readyFn) {
            hrefs = hrefs.filter(function(href) {
                return href.trim() !== '';
            });

            var loadCount = hrefs.length;

            if(loadCount === 0) {
                readyFn();
                return;
            }

            hrefs.forEach(function(href) {
                real.dom.appendStylesheet(href, function() {
                    loadCount--;
                    if(loadCount === 0 && typeof readyFn === 'function') {
                        readyFn();
                    }
                });
            });
        },

        appendScripts : function(srcs, readyFn) {
            srcs = srcs.filter(function(src) {
                return src.trim() !== '';
            });

            var loadCount = srcs.length;

            if(loadCount === 0) {
                if (typeof readyFn === 'function') {
                    readyFn();
                }
                return;
            }

            srcs.forEach(function(src) {
                real.dom.appendScript(src, function() {
                    loadCount--;
                    if(loadCount === 0 && typeof readyFn === 'function') {
                        readyFn();
                    }
                });
            });
        },

        appendResources : function(hrefs, srcs, readyFn) {
            var hrefsReady = false, srcsReady = false, checkReady;

            checkReady = function() {
                if(hrefsReady && srcsReady && typeof readyFn === 'function') {
                    readyFn();
                }
            };

            real.dom.appendStylesheets(hrefs, function() {
                hrefsReady = true;
                checkReady();
            });

            real.dom.appendScripts(srcs, function() {
                srcsReady = true;
                checkReady();
            });
        },

        disable : function(elem) {
            elem.findIncludingSelf(toggleDisabledSelector).each(function(i, childElem) {
                childElem = $(childElem);

                childElem.data('was-originally-disabled', childElem.prop('disabled'));
                childElem.data('had-originally-disabled-class', childElem.is('.disabled'));

                childElem.prop('disabled', true).addClass('disabled');

                if(childElem.is('[type="checkbox"]')) {
                    childElem.closest('.form-check').addClass('disabled');
                }
            });
        },

        enable : function(elem) {
            elem.findIncludingSelf(toggleDisabledSelector).each(function(i, childElem) {
                childElem = $(childElem);

                if(!childElem.data('was-originally-disabled')) {
                    childElem.prop('disabled', false);
                }

                if(!childElem.data('had-originally-disabled-class')) {
                    childElem.removeClass('disabled');
                    if(childElem.is('[type="checkbox"]')) {
                        childElem.closest('.form-check').removeClass('disabled');
                    }
                }

                childElem.removeDataAndAttr('was-originally-disabled had-originally-disabled-class');
            });
        },

        setRandomDelays : function(seconds) {
            addRandomDelaysMaxSeconds = seconds;
        }

    };

})();
